import { render, staticRenderFns } from "./CustomerTravelsTab.vue?vue&type=template&id=6193e904&scoped=true&"
import script from "./CustomerTravelsTab.vue?vue&type=script&lang=js&"
export * from "./CustomerTravelsTab.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTravelsTab.vue?vue&type=style&index=0&id=6193e904&prod&lang=sass&"
import style1 from "./CustomerTravelsTab.vue?vue&type=style&index=1&id=6193e904&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6193e904",
  null
  
)

export default component.exports